__turbopack_context__.v({
  "BlobCenter1": "_1GoZuW_BlobCenter1",
  "BlobLeft1": "_1GoZuW_BlobLeft1",
  "BlobRight1": "_1GoZuW_BlobRight1",
  "Chevron": "_1GoZuW_Chevron",
  "ChevronOpen": "_1GoZuW_ChevronOpen",
  "FunFact": "_1GoZuW_FunFact",
  "FunFactVisible": "_1GoZuW_FunFactVisible",
  "GreenBlue": "_1GoZuW_GreenBlue",
  "ImageContent": "_1GoZuW_ImageContent",
  "ImageContentInsights": "_1GoZuW_ImageContentInsights",
  "ImageGlass": "_1GoZuW_ImageGlass",
  "ImageInsightsWrapper": "_1GoZuW_ImageInsightsWrapper",
  "ImageLink": "_1GoZuW_ImageLink",
  "ImageTagline": "_1GoZuW_ImageTagline",
  "ImageText": "_1GoZuW_ImageText",
  "ImageTextInsights": "_1GoZuW_ImageTextInsights",
  "ImageTitle": "_1GoZuW_ImageTitle",
  "ImageTitleInsights": "_1GoZuW_ImageTitleInsights",
  "Insights": "_1GoZuW_Insights",
  "IsActive": "_1GoZuW_IsActive",
  "LeftColumn": "_1GoZuW_LeftColumn",
  "MegaMenu": "_1GoZuW_MegaMenu",
  "MegaMenuButton": "_1GoZuW_MegaMenuButton",
  "MegaMenuButtonOpen": "_1GoZuW_MegaMenuButtonOpen",
  "MegaMenuCloseButton": "_1GoZuW_MegaMenuCloseButton",
  "MegaMenuInsightsTitle": "_1GoZuW_MegaMenuInsightsTitle",
  "MegaMenuItem": "_1GoZuW_MegaMenuItem",
  "MegaMenuItemWrapper": "_1GoZuW_MegaMenuItemWrapper",
  "MegaMenuItemsWrapper": "_1GoZuW_MegaMenuItemsWrapper",
  "MegaMenuLink": "_1GoZuW_MegaMenuLink",
  "MegaMenuText": "_1GoZuW_MegaMenuText",
  "MegaMenuWrapper": "_1GoZuW_MegaMenuWrapper",
  "NavigationDesktop": "_1GoZuW_NavigationDesktop",
  "NavigationDesktopLink": "_1GoZuW_NavigationDesktopLink",
  "PinkBlue": "_1GoZuW_PinkBlue",
  "PinkOrange": "_1GoZuW_PinkOrange",
  "PinkPurple": "_1GoZuW_PinkPurple",
  "PurpleBlue": "_1GoZuW_PurpleBlue",
  "RightColumn": "_1GoZuW_RightColumn",
  "Root": "_1GoZuW_Root",
  "Spotlight": "_1GoZuW_Spotlight",
});
